import * as R from "@bracket/rabbit/mqtt";
import * as G from "@globals";
import type { IBracketStore, } from "@store/types";
import { produce } from 'immer';
import type { StateCreator, } from "zustand";
import type { Store } from '../useStore';
import { awaitTruthy, } from "@store/helpers";
import { gql, } from "./helpers";
import type{ IMessagesSlice, ListenerFunction, ListenerMsg, Message, } from "./types";



export const createMessagesSlice: StateCreator<IBracketStore, [], [], IMessagesSlice> = ( set, get, ) => {


	const fetch = async () => {

		const { useStore, } = await import("@store");
		await awaitTruthy(useStore, state => state.wallet.ready);

		const {
			loaded,
			fetching,
		} = get().msg;

		if(!loaded && !fetching) {

			set(produce<Store>(state => {
				state.msg.fetching = true;
			}));

			const { notifications:messages, } = await gql("LOAD_MESSAGES") as { notifications: Message[]; };

			await connect();

			set(produce<Store>(state => {
				state.msg.messages = messages;
				state.msg.fetching = false;
				state.msg.loaded = true;
				state.msg.connected = true;
				state.msg.messages = messages;
				state.msg.total = messages.length;
				state.msg.unread = messages.filter(n => n.status !== "READ").length;
				state.msg.read = messages.filter(n => n.status === "READ").length;
			}));

		}

		set(produce<Store>(state => {
			state.msg.ready = true;
			state.msg.fetching = false;
		}));
	}


	const connect = async () => {
		const { address } = G.wallet.getBracketWallet();
		const disconnector = await R.subscribe([
			"wallets.all",
			`wallets.${address?.toLowerCase()}`
		], async  (msg, _) => {
			await refetch();
			await Promise.all(get().msg.listeners.map(fn => fn(msg as ListenerMsg)));
		});
		_disconnector = disconnector;

		set(produce<Store>(state => {
			state.notificationSlice.connected = true;
		}));

	};


	const disconnect = () => {
		if(_disconnector) {
			_disconnector();
			_disconnector = null;
		}
		set(produce<Store>(state => {
			state.msg.connected = false;
		}));
	};


	const markRead = async ( _:unknown, ) => { };


	const onWalletMessage = ( fn: ListenerFunction ) => {
		const { listeners, } = get().msg;
		if(listeners.includes(fn)) return;
		set(produce<Store>(state => {
			state.msg.listeners.push(fn);
		}));
	};


	const clear = ( type: "WALLET", fn: ListenerFunction ) => {
		if(type === "WALLET") {
			const listeners = get().msg.listeners.filter(l => l !== fn);
			set(produce<Store>(state => {
				state.msg.listeners = listeners;
			}));
		}
	};


	const refetch = async () => {
		const { notifications:messages, } = await gql("LOAD_MESSAGES") as { notifications: Message[]; };
		set(produce<Store>(state => {
			state.msg.messages = messages;
			state.msg.total = messages.length;
			state.msg.unread = messages.filter(n => n.status !== "READ").length;
			state.msg.read = messages.filter(n => n.status === "READ").length;
		}));
	};


	const reset = () => {
		console.warn("store:messages::reset:: not implemented");
	};


	const resetAsync = async () => {
		console.warn("store:messages::resetAsync:: not implemented");
	};


	let _disconnector: Awaited<ReturnType<typeof R.subscribe>> | null = null;	

	// place at the bottom of the call stack.
	// setTimeout(() => fetch(), 0);



	return {
		ready: false,
		fetching: false,
		loaded: false,
		connected: false,
		unread: 0,
		read: 0,
		total: 0,
		messages: [],
		listeners: [],
		fetch,
		refetch,
		connect,
		disconnect,
		markRead,
		onWalletMessage,
		clear,
		reset,
		resetAsync,
	};

};
